"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabMenu = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    width: 1px;\n    height: 32px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    z-index:1;\n    cursor: ", ";\n    // cursor: pointer ;\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    align-items: center;\n    width: ", ";\n    color: ", ";\n    justify-content: center;\n    line-height: ", "px;\n\n\n\n    ", "\n\n    ", "\n\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    height: ", "px;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    background-color: ", ";\n    opacity: ", ";\n    transition: all .15s;\n    z-index: -10;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    font-weight: 600;\n    font-family: ", ";\n    flex-direction: row;\n    border-bottom: 1px ", " solid;    \n    width: fit-content;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabItemWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.fontFamilyObj;
}, function (props) {
  return props.colorObj.separatorColor;
});

var BlueLine = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.type == 'strong' ? props.spacingObj.height : 2;
}, function (props) {
  return props.colorObj.hoverColor;
}, function (props) {
  return props.selected ? 1 : 0;
});

var TabItem = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.width ? props.width : 'fit-content';
}, function (props) {
  return props.selected ? props.colorObj.activeTextColor : props.colorObj.textColor;
}, function (props) {
  return props.spacingObj.height;
}, function (props) {
  return !props.selected && !props.disabled && "\n        &:hover ".concat(BlueLine, "{\n            height: 100%;\n            transition: all 0.15s;\n            opacity: 0.1;\n        }\n        &:hover{\n            color: ").concat(props.colorObj.hoverColor, ";\n        }\n        &:active ").concat(BlueLine, "{\n            opacity: 0.2;\n        }");
}, function (props) {
  return props.disabled && "\n        color: ".concat(props.colorObj.disabledColor, ";\n    ");
});

var Separator = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.colorObj.separatorColor;
});
/**
 * TabMenus have flexible configurations for situations where you want to toggle between values within the selector, or it can be configured through the child Item elements to toggle between content areas.
 * The Item components define both the title of each tab, as well as the content ot show when that item is selected. Content to show is added by including the content in the body of the component. They can also be passed a 'disabled' prop to disable that particular tab item.
 * Available functions via refs:
 * - setSelected(integer TabIndex): set the selected tab to the tab at the given index.
 * @example import { TabMenu } from '@desktop/react';
 */


var TabMenu = (0, _react.forwardRef)(function (props, ref) {
  var inherit = 'tabmenu';
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);

  var _useState = (0, _react.useState)(props.selected),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var color = context.getColors()[inherit][props.type];
  var spacing = context.getSpacing()[inherit];
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      setSelected: setSelected
    };
  });
  (0, _react.useEffect)(function () {
    _setChildrenMap();
  }, [props.children]);

  function _setChildrenMap() {
    var selected = props.selected;
    props.children.map(function (item, pos) {
      if (item.props.selected) {
        selected = pos;
      }
    });
    setSelected(selected);
  }

  function clickItem(e) {
    if (!props.disabled) {
      var pos = e.currentTarget.getAttribute("data-itemid") * 1;
      var value = e.currentTarget.getAttribute("data-value");
      if (pos !== selected) setSelected(pos);
      props.onClick(e, pos, value);
    }
  }

  var items = [];
  var content = [];
  props.children.map(function (item, pos) {
    var disabled = props.disabled || item.props.disabled;
    var isSelected = selected === pos;
    items.push( /*#__PURE__*/_react["default"].createElement(TabItem, _extends({
      selected: disabled ? false : isSelected,
      colorObj: color,
      onClick: disabled ? null : clickItem,
      "data-value": item.props.value,
      "data-itemid": pos,
      key: "item" + pos,
      spacingObj: spacing,
      width: props.itemWidth,
      disabled: disabled
    }, item.props), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: "0 ".concat(props.width ? 0 : spacing.padding * 3, "px")
      }
    }, item.props.label ? item.props.label : item.props.children), props.showSeparator && pos !== props.children.length - 1 && /*#__PURE__*/_react["default"].createElement(Separator, {
      colorObj: color,
      spacingObj: spacing
    }), !disabled && /*#__PURE__*/_react["default"].createElement(BlueLine, {
      key: "line " + pos,
      type: props.type,
      colorObj: color,
      spacingObj: spacing,
      selected: isSelected
    })));
    content.push(item.props.children ? item.props.children : null);
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(TabItemWrapper, {
    style: props.style,
    colorObj: color,
    fontFamilyObj: context.getFont()
  }, items), /*#__PURE__*/_react["default"].createElement("div", {
    style: props.contentStyle
  }, content[selected]));
});
exports.TabMenu = TabMenu;
TabMenu.propTypes = {
  /**Styles the tabmenu based on the specified type. This can be strong or default. */
  type: _propTypes["default"].string,

  /**Callback function fired when one of the tabs are clicked. */
  onClick: _propTypes["default"].func,

  /**Extends the base styling of the TabMenu selector element. */
  style: _propTypes["default"].object,

  /**Extends the content area container of the TabMenu base styling. */
  contentStyle: _propTypes["default"].object,

  /** CSS property that defines the width of the tab items. */
  itemWidth: _propTypes["default"].string,

  /** Boolean that will display seperators between the tabs. */
  showSeparator: _propTypes["default"].bool,

  /** Boolean for if the button is enabled or disabled */
  disabled: _propTypes["default"].bool,

  /** Number to set which tab is selected. Null will show none as selected*/
  selected: _propTypes["default"].number
};
TabMenu.defaultProps = {
  style: {},
  contentStyle: {},
  type: 'default',
  onClick: function onClick() {
    return false;
  },
  itemWidth: null,
  showSeparator: false,
  disabled: false,
  selected: 0
};